/**
 * Submit partner interest-list signup.
 * @param {import('axios').AxiosInstance} api
 * @param {{ email: string, companyName?: string, website_url?: string }} payload
 */
export const submitPartnerInterest = async (api, payload) => {
  const email = (payload.email || '').trim().toLowerCase();
  if (!email || !email.includes('@')) {
    const error = new Error('Valid email is required');
    error.code = 'INVALID_EMAIL';
    throw error;
  }

  const response = await api.post('/partners/interest', {
    email,
    companyName: payload.companyName?.trim() || undefined,
    website_url: payload.website_url || '',
    source: payload.source || 'partner_page',
  });

  return response.data;
};

export const submitPartnerDemoRequest = async (api, payload) => {
  const email = (payload.email || '').trim().toLowerCase();
  const name = (payload.name || '').trim();
  const business = (payload.business || '').trim();
  const phone = (payload.phone || '').trim();
  const location = (payload.location || '').trim();
  const businessDescription = (payload.businessDescription || '').trim();

  if (!email || !email.includes('@')) {
    const error = new Error('Valid email is required');
    error.code = 'INVALID_EMAIL';
    throw error;
  }

  if (!name) {
    const error = new Error('Name is required');
    error.code = 'MISSING_FIELDS';
    throw error;
  }

  if (business.length < 3) {
    const error = new Error('Company name must be at least 3 characters');
    error.code = 'COMPANY_TOO_SHORT';
    throw error;
  }

  const response = await api.post('/partners/demo-request', {
    name,
    business,
    email,
    phone: phone || undefined,
    location: location || undefined,
    businessDescription: businessDescription || undefined,
    website_url: payload.website_url || '',
  });

  return response.data;
};

export const submitPartnerDemoBooking = async (api, payload) => {
  const email = (payload.email || '').trim().toLowerCase();
  if (!email || !email.includes('@')) {
    const error = new Error('Valid email is required');
    error.code = 'INVALID_EMAIL';
    throw error;
  }
  if (!payload.scheduledAt) {
    const error = new Error('Meeting time is required');
    error.code = 'MISSING_MEETING_TIME';
    throw error;
  }

  const response = await api.post('/partners/demo-booked', {
    name: payload.name?.trim() || undefined,
    business: payload.business?.trim() || undefined,
    email,
    phone: payload.phone?.trim() || undefined,
    location: payload.location?.trim() || undefined,
    businessDescription: payload.businessDescription?.trim() || undefined,
    scheduledAt: payload.scheduledAt,
    timezone: payload.timezone?.trim() || undefined,
    inviteeNotes: payload.inviteeNotes?.trim() || undefined,
  });

  return response.data;
};

export const getPartnerInterestErrorMessage = (error, t) => {
  if (error?.code === 'INVALID_EMAIL') {
    return t('partnerPage.interest.invalidEmail');
  }

  if (error?.code === 'MISSING_FIELDS') {
    return t('partnerPage.demo.missingFields');
  }

  if (error?.code === 'COMPANY_TOO_SHORT') {
    return t('partnerPage.demo.companyTooShort');
  }

  const status = error?.response?.status;
  const details = error?.response?.data?.details;
  const serverMessage = error?.response?.data?.error;

  if (status === 429) {
    return t('partnerPage.interest.rateLimited');
  }

  if (Array.isArray(details) && details.length > 0) {
    return details.join(' ');
  }

  if (serverMessage && typeof serverMessage === 'string' && serverMessage !== 'Validation failed') {
    return serverMessage;
  }

  return t('partnerPage.interest.error');
};
